import React from 'react';
import './OrderSeatSummary.scss';
import { FormattedMessage } from 'react-intl';
import PriceItem from 'Components/Shared/PriceItem/PriceItem';

interface IProps {
  isMobile: boolean;
  isTimeSlot?: boolean;
  orderSeats: Julius.Website.OrderSeatViewModel;
}

const OrderSeat: React.SFC<IProps> = ({ 
  isMobile,
  isTimeSlot,
  orderSeats,
  orderSeats: {
    categoryName, 
    discountName, 
    rowNbr, 
    seatNbr, 
    sectionName,
    price, 
    reducedPrice, 
    isNumberedSeat,
  },
}) => {

  if (!orderSeats) {
    return null;
  }

  const isReduced = price !== reducedPrice;
  const priceStyle = isReduced ? 'overline' : '';

  const descriptionComponent = (
    <div>
      <span className='sub-title medium-bold'>
        <FormattedMessage 
          id='order.tickets.category'
          defaultMessage='Biljetter - '
          values={ { priceCategory: categoryName } }
        />
      </span>
      <span>{ discountName }</span>
    </div>
  );

  const locationComponent = (
    isTimeSlot ?
      <div>
        { sectionName }
      </div> :
      <div>
        <FormattedMessage 
          id='order.tickets.seat'
          defaultMessage=''
          values={ { rowNbr, seatNbr  } }
        />
        <div>
          { sectionName }
        </div>
      </div>
  );

  const priceComponent = (
    <div>
      <PriceItem 
        style={ `medium-bold price ${ priceStyle }` } 
        price={ price } 
        decimals={ 2 } 
      />
      { isReduced && 
        <PriceItem 
          style='medium-bold price reduced' 
          price={ reducedPrice } 
          decimals={ 2 } 
        /> 
      }
    </div>
  )

  if (isMobile) {
    return (
      <tr className='order-seat'>
      <td>{ descriptionComponent }</td>
      { (isNumberedSeat || isTimeSlot) ? <td>{ locationComponent }</td> : <td>{ sectionName }</td> }
      <td>{ priceComponent }</td>
    </tr>
    );
  }

  return (
    <tr className='order-seat'>
      <td>{ descriptionComponent }</td>
      { (isNumberedSeat || isTimeSlot) ? <td>{ locationComponent }</td> : <td>{ sectionName }</td> }
      <td>{ priceComponent }</td>
    </tr>
  );
};

export default OrderSeat;


// WEBPACK FOOTER //
// ./src/components/OrderSeatSummary/OrderSeat.tsx